/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
   providedIn: 'root'
})
export class WeatherApiConfiguration {
   rootUrl: string = '';
}

/**
 * Parameters for `WeatherApiModule.forRoot()`
 */
export interface WeatherApiConfigurationParams {
   rootUrl?: string;
}
